<template>
  <div class="main-wrapper">
    <div class="login-pages">
      <div class="container-fluid">
        <div class="row align-items-center">
          <div class="col-lg-12">
            <div class="login-logo">
              <img src="@/assets/admin_img/logo-login.png" alt="img" />
            </div>
          </div>
          <div class="col-lg-6">
            <div class="login-images">
              <img src="@/assets/admin_img/login-banner.png" alt="img" />
            </div>
          </div>
          <div class="col-lg-6">
            <div class="login-content">
              <div class="login-contenthead">
                <h5>Create an Account</h5>
                <h6>Continue where you left off</h6>
              </div>
              <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
                <div class="form-group">
                  <label>Name</label>
                  <input type="text" class="form-control" placeholder="Name" />
                </div>
                <div class="input-block mb-4">
                  <label class="col-form-label">E-mail</label>
                  <Field
                    name="email"
                    type="text"
                    value="example@dreamguys.com"
                    class="form-control"
                    :class="{ 'is-invalid': errors.email }"
                  />
                  <div class="invalid-feedback">{{ errors.email }}</div>
                  <div class="emailshow text-danger" id="email"></div>
                </div>
                <div class="input-block mb-4">
                  <div class="row align-items-center">
                    <div class="col">
                      <label class="col-form-label">Password</label>
                    </div>
                    <div class="col-auto">
                      <router-link class="text-muted" to="forgot-password">
                        Forgot password?
                      </router-link>
                    </div>
                  </div>
                  <div class="position-relative pass-group">
                    <Field
                      name="password"
                      :type="showPassword ? 'text' : 'password'"
                      value="123456"
                      class="form-control pass-input mt-2"
                      :class="{ 'is-invalid': errors.password }"
                    />
                    <span @click="toggleShow" class="toggle-password">
                      <i
                        :class="{
                          'fas fa-eye': showPassword,
                          'fas fa-eye-slash': !showPassword,
                        }"
                      ></i>
                    </span>
                    <div class="invalid-feedback">{{ errors.password }}</div>
                    <div class="emailshow text-danger" id="password"></div>
                  </div>
                  <div class="filter-checkbox mt-3">
                    <ul class="d-flex justify-content-between">
                      <li>
                        <label class="checkboxs">
                          <input type="checkbox" />
                          <span><i></i></span>
                          <b class="check-content">Remember Me</b>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="login-button">
                  <router-link to="/home/" class="btn btn-login">Login</router-link>
                </div>
                <div class="signinform text-center">
                  <h4>
                    Don’t have an account?
                    <router-link to="signup" class="hover-a">Sign Up</router-link>
                  </h4>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import { router } from "@/router";
export default {
  components: {
    Form,
    Field,
  },
  data() {
    return {
      showPassword: false,
      password: null,
      emailError: "",
      passwordError: "",
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    onSubmit(values) {
      this.emailError = "";
      this.passwordError = "";

      let data = localStorage.getItem("storedData");
      var Pdata = JSON.parse(data);
      const Eresult = Pdata.find(({ email }) => email === values.email);
      if (Eresult) {
        if (Eresult.password === values.password) {
          this.$router.push("admin-dashboard"); // Use this.$router instead of router
        } else {
          this.passwordError = "Incorrect password";
        }
      } else {
        this.emailError = "Email is not valid";
      }
    },
  },
  setup() {
    let users = localStorage.getItem("storedData");
    if (users === null) {
      let password = [
        {
          email: "example@dreamguys.com",
          password: "123456",
        },
      ];
      const jsonData = JSON.stringify(password);
      localStorage.setItem("storedData", jsonData);
    }
    const schema = Yup.object().shape({
      email: Yup.string().required("Email is required").email("Email is invalid"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    });
    return {
      schema,
    };
  },
};
</script>
